<div class="kinetics-graph" id="kinetics-graph">
  <app-water-mark></app-water-mark>
</div>
